import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {takeEvery, call, select} from 'redux-saga/effects';

import {CHECKOUT_RISKIFIED} from 'constants/analytics/events/checkout';
import {RISKIFIED_STATUS_USE} from 'constants/riskified';
import {PAYMENTS} from 'desktop/pages/checkout/constants/paymentStep';

import {completeOrderReview} from '../../actions/completeOrder/completeOrder';
import {getCompleteOrderResult} from '../../selectors/completeOrder/completeOrder';
import {getNameSelectedMethod} from '../../selectors/paymentStep/paymentStep';

/**
 * Send riskified events.
 */
export function* reportRiskified() {
    // TODO Alex get rid of direct ga use completely completely
    if (__NODEJS__) return;
    const method: string = yield select(getNameSelectedMethod);
    if (method !== PAYMENTS.METHOD_CREDIT_CARD) return;
    const {riskified_message: message, riskified_status: status} =
        yield select(getCompleteOrderResult);
    const description = message ? ` - ${message}` : '';

    if (!status) return;

    yield call(
        sendDesktopAnalyticsEvent,
        CHECKOUT_RISKIFIED,
        {
            message: `${RISKIFIED_STATUS_USE[status]}${description}`,
        },
        false,
    );
}

/**
 *  Begin of saga.
 */
export function* riskified() {
    yield takeEvery(
        [`${completeOrderReview.fulfilled}`, `${completeOrderReview.rejected}`],
        reportRiskified,
    );
}
